export function getSmartMaxY(maxValue: number, paddingFactor = 1.1): number {
  if (maxValue === 0) return 1;

  const paddedMax = maxValue * paddingFactor;
  const exponent = Math.floor(Math.log10(paddedMax));
  const base = Math.pow(10, exponent);

  const stepCandidates = [1, 2, 2.5, 3, 4, 5, 6, 7.5, 8, 9, 10];

  for (const step of stepCandidates) {
    const candidate = step * base;
    if (candidate >= paddedMax) {
      return candidate;
    }
  }

  return 10 * base;
}
